import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import FormattedCurrency from 'components/ui/FormattedCurrency';
import { passengersShape, legShape } from 'constants/propTypes';
import { isGroupBooking } from 'utils/isGroupBooking';

import TravelInfo from '../JourneySegment/TravelInfo';
import PaxInfo from '../JourneySegment/PaxInfo';
import TravelSummary from '../JourneySegment/TravelSummary';
import { SegmentTotal } from '../JourneyDigest.styles';

const JourneyDetails = ({ journey, paxDetails, direction, currency, isBookingMice, infantCount, isLoyaltyBooking = false }) => {
  const isGroup = isGroupBooking(journey?.productFamily?.familyGroup);

  return (
    <>
      <TravelSummary
        departureDate={journey.date}
        originName={journey.origin.name}
        destinationName={journey.destination.name}
        paxDetails={paxDetails}
        classOfService={journey?.classOfService}
      />

      <TravelInfo
        departureTime={journey.departureTime}
        arrivalTime={journey.arrivalTime}
        origin={journey.origin}
        destination={journey.destination}
        direction={direction}
        fareName={journey.legs?.products?.[0]?.name || journey.productFamily?.name}
        classOfService={journey?.classOfService}
        isBookingMice={isBookingMice}
      />

      <PaxInfo
        paxDetails={paxDetails}
        currency={currency}
        shouldShowBucketCode={isGroup}
        infantCount={infantCount}
        isLoyaltyBooking={isLoyaltyBooking}
      />
      <SegmentTotal>
        <span data-id="segment-total">
          <FormattedMessage id="journeySummary.segmentTotal" />
          :&nbsp;
          <FormattedCurrency
            currency={currency}
            amount={paxDetails.reduce((acc, pax) => {
              const price = pax.price || 0;
              return acc + price;
            }, 0)}
          />
        </span>
      </SegmentTotal>
    </>
  );
};

JourneyDetails.propTypes = {
  journey: legShape,
  paxDetails: passengersShape.isRequired,
  direction: PropTypes.string,
  currency: PropTypes.string,
  isBookingMice: PropTypes.bool,
  infantCount: PropTypes.number,
  isLoyaltyBooking: PropTypes.bool
};

export default JourneyDetails;
